export default "__VITE_PUBLIC_ASSET__558778d2__"